import type { ReactNode } from 'react';

type Tone = 'info' | 'success' | 'warning' | 'danger';

interface AlertProps {
  tone?: Tone;
  title?: string;
  children: ReactNode;
}

const TONES: Record<Tone, string> = {
  info: 'bg-primary-soft text-primary border-primary/20',
  success: 'bg-success-soft text-success border-success/20',
  warning: 'bg-warning-soft text-warning border-warning/20',
  danger: 'bg-danger-soft text-danger border-danger/20',
};

export function Alert({ tone = 'info', title, children }: AlertProps): ReactNode {
  return (
    <div
      // `assertive` solo en los errores: los avisos informativos no deben
      // interrumpir a quien usa lector de pantalla.
      role={tone === 'danger' ? 'alert' : 'status'}
      className={`rounded-card border px-4 py-3 text-sm ${TONES[tone]}`}
    >
      {title ? <p className="mb-0.5 font-semibold">{title}</p> : null}
      <div>{children}</div>
    </div>
  );
}
